import { render } from "./MemberAssessmentRow.vue?vue&type=template&id=2268aa34&scoped=true"
import script from "./MemberAssessmentRow.vue?vue&type=script&lang=js"
export * from "./MemberAssessmentRow.vue?vue&type=script&lang=js"

import "./MemberAssessmentRow.vue?vue&type=style&index=0&id=2268aa34&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2268aa34"

export default script